import { jsx as _jsx } from "react/jsx-runtime";
import { Row as BootstrapRow } from 'react-bootstrap';
import styles from './Row.module.scss';
const Row = ({ className = '', children, noGutters = false }) => {
    // noGutters foi removido no React Bootstrap v5
    // Usar classes CSS para remover gutters se necessário
    const rowClass = noGutters
        ? `${styles.row} ${styles.noGutters} ${className}`
        : `${styles.row} ${className}`;
    return (_jsx(BootstrapRow, { className: rowClass, children: children }));
};
export default Row;
